/* eslint-disable max-len */
import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ConditionVerticalIcon: FC<IconProps> = props => (
  <BaseIcon {...props}>
    <path d="M17 11.5859L24.4141 19C24.7891 19.375 25 19.8837 25 20.4141V24H26.793C27.2383 24.0001 27.4614 24.5385 27.1465 24.8535L24.3535 27.6465C24.1583 27.8417 23.8417 27.8417 23.6465 27.6465L20.8535 24.8535C20.5386 24.5385 20.7616 24 21.207 24H23V20.4141L16 13.4141L8.99999 20.4141V24H10.793C11.2383 24.0001 11.4613 24.5386 11.1465 24.8535L8.35351 27.6465C8.15827 27.8417 7.84174 27.8417 7.64648 27.6465L4.85351 24.8535C4.53853 24.5385 4.76158 24 5.20702 24H6.99999V20.4141C7.00003 19.8837 7.21089 19.375 7.58593 19L15 11.5859V4H17V11.5859Z" />
  </BaseIcon>
);
